import { PaymentOption, RenewalDetails } from '@domgen/dgx-fe-basket';
import { CheckoutCompletedRenewalConfirmation } from '../checkout-completed-item/checkout-completed-renewal-confirmation.interface';

export interface CompletedRenewalDetails
  extends RenewalDetails,
    CheckoutCompletedRenewalConfirmation {
  purchasedPaymentOption: PaymentOption;
}
